import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {AnimatedParticle, Emitter} from "pixi-particles";
import {FruitsLayerConfig} from "../../../config/FruitsLayerConfig";
import {FruitsParticleConfig} from "../../../config/FruitsParticleConfig";
import {FruitsGameAssets} from "../../FruitsGameAssets";


/**
 * Created by h3 on 2018-10-05.
 */


export class FruitsParticles extends BaseView {

    private _layer:ScalableLayer;
    private _temporaryContainer:PIXI.Container;
    private _screenWidth:number;
    private _screenHeight:number;
    private _leftOffset:number;
    private _topOffset:number;
    private _centerX:number;
    private _centerY:number;
    private _particleTextures:PIXI.Texture[][];
    private _emitters:Emitter[];
    private _particleDuration:number[];
    private _particlesActive:boolean = false;


    constructor() {
        super(ResourcesGroupName.MAIN);
        this._layer = StageManager.getLayer(FruitsLayerConfig.FRUITS_PARTICLES.name);

    }

    protected initAnimations():void {
        this._temporaryContainer = new PIXI.Container();
        this._layer.addChild(this._temporaryContainer);

        this._particleTextures = [
            GameResources.getTextures(FruitsGameAssets.BW_GRAPE_SEQ),
            GameResources.getTextures(FruitsGameAssets.BW_SBERRY_SEQ),
            GameResources.getTextures(FruitsGameAssets.BW_STAR_SEQ)
        ];

        this._particleDuration = [18, 14, 8];

    }

    protected onResize(resizeData:IResizeData):void {
        this._screenWidth = resizeData.width / this._layer.scale.x;
        this._screenHeight = resizeData.height / this._layer.scale.y;
        this._leftOffset = -this._layer.x / this._layer.scale.x;
        this._topOffset = -this._layer.y / this._layer.scale.y;

        this._centerX = this._screenWidth / 2 + this._leftOffset;
        this._centerY = this._screenHeight / 2 + this._topOffset;

        this.updateEmitterSpawnPositions(resizeData.orientation === Orientation.PORTRAIT);
    }

    private createAnimatedParticleEmitters():Emitter[] {

        const emitters = [];


        for (let i:number = 0; i < this._particleTextures.length; i++) {
            //let blendmode = (i === 2 ? "add" : "normal");
            let blendmode = "normal";
            let emitter = this.createEmitter(this._particleTextures[i], this._particleDuration[i], blendmode);
            emitters.push(emitter);
        }

        return emitters;

    }

    private createEmitter(textures:PIXI.Texture[], duration:number, blendMode?:string):Emitter {

        const container = new PIXI.Container();

        const emitter = new Emitter(
            container,
            [{
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : textures
            }],
            FruitsParticleConfig.getBigWinConfig(duration, blendMode)
        );
        emitter.particleSpacing = 1;
        emitter.particleConstructor = AnimatedParticle;
        emitter.emit = false;
        emitter.cleanup();
        emitter.rotate(1);
        this._temporaryContainer.addChild(container);

        return emitter;
    }

    public prepareParticleEmitter():void {
        this._emitters = this.createAnimatedParticleEmitters();
    }

    public startFruitEmitter(startLevel:number):void {

        if(startLevel === 0) {
            //this._emitters = this.createAnimatedParticleEmitters();
            this._temporaryContainer.alpha = 1;

        }
        ParticlesManager.addEmitter(this._emitters[startLevel]);
        this._emitters[startLevel].maxParticles = 128;
        this._emitters[startLevel].emit = true;
        this._particlesActive = true;


    }

    public startBonusEmitter() {
        this._emitters = this.createAnimatedParticleEmitters();
        this._temporaryContainer.alpha = 1;

        this._emitters.forEach( emitter => {
            ParticlesManager.addEmitter(emitter);
            emitter.maxParticles = 128;
            emitter.emit = true;
        });
        this._particlesActive = true;
    }

    public getResetEmitters():void {

        if (!this._particlesActive) {
            return;
        }

        const tl:TimelineLite = new TimelineLite();
        tl.add(TweenLite.fromTo(this._temporaryContainer, 0.6,{alpha: 1}, {alpha: 0}));
        tl.add(() => {
            this.clearEmitters();
            this._temporaryContainer.removeChildren();
        });
    }

    private clearEmitters():void {
        this._emitters.forEach((emitter) => {
            emitter.emit = false;
            ParticlesManager.removeEmitter(emitter);
            emitter.cleanup();
            emitter.destroy();
        });
    }

    private updateEmitterSpawnPositions(isPortrait:boolean):void {

        this._temporaryContainer.position.set(this._centerX, this._centerY);

        //if(this._allEmitters.length > 0) {
        //    this._allEmitters.forEach((emitter) => {
        //        emitter.updateSpawnPos(FruitsGameConfig.instance.GAME_WIDTH / 2, this._screenHeight * (isPortrait ? 0.9 : 1.0));
        //        emitter.minLifetime = isPortrait ? 8 : 6;
        //        emitter.maxLifetime = isPortrait ? 10 : 8;
        //    });
        //}
    }
}